(function(){
'use strict';
if(window.__elzGal)return;window.__elzGal=true;
var $=function(s,r){return(r||document).querySelector(s)};
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
function slides(p){return $$('.elz-gal__slide',p)}
function cur(p){var s=slides(p);for(var i=0;i<s.length;i++)if(s[i].classList.contains('is-active'))return i;return 0}
function sync(p){
  var s=slides(p),i=cur(p),c=$('[data-gal-count]',p);
  if(c)c.textContent=(i+1)+' / '+s.length;
  var t=$$('.elz-gal__thumb',p)[i];
  if(t){var box=t.parentNode;try{box.scrollTo({left:t.offsetLeft-box.clientWidth/2+t.clientWidth/2,top:t.offsetTop-box.clientHeight/2+t.clientHeight/2,behavior:'smooth'})}catch(e){}}
}
function show(p,i){
  var s=slides(p),t=$$('.elz-gal__thumb',p);if(!s.length)return;
  i=(i+s.length)%s.length;
  s.forEach(function(x,k){x.classList.toggle('is-active',k===i)});
  t.forEach(function(x,k){x.classList.toggle('is-active',k===i);x.setAttribute('aria-selected',k===i?'true':'false')});
  sync(p);
}
function lbSet(p){
  var sl=slides(p)[cur(p)],lb=$('[data-elz-lightbox]',p),img=sl&&$('img',sl);
  if(!lb)return;
  var im=$('img',lb);if(!im)return;
  var src=sl&&(sl.dataset.full||(img&&(img.currentSrc||img.src)));
  if(src)im.src=src;
}
document.addEventListener('click',function(e){
  var g=e.target.closest('[data-gal]');
  if(g){var p=g.closest('[data-elz-pdp]');show(p,cur(p)+(g.dataset.gal==='next'?1:-1));return}
  var l=e.target.closest('[data-lb]');
  if(l){var q=l.closest('[data-elz-pdp]');show(q,cur(q)+(l.dataset.lb==='next'?1:-1));lbSet(q)}
});
document.addEventListener('change',function(e){
  var r=e.target.closest('[data-elz-opts] input');if(!r)return;
  var o=r.closest('.elz-opt'),l=o&&$('[data-opt-val]',o);if(l)l.textContent=r.value;
});
document.addEventListener('keydown',function(e){
  if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;
  var d=e.key==='ArrowRight'?1:-1;
  var lb=$('[data-elz-lightbox].is-open');
  if(lb){var p=lb.closest('[data-elz-pdp]');show(p,cur(p)+d);lbSet(p);return}
  var st=document.activeElement&&document.activeElement.closest&&document.activeElement.closest('.elz-gal__stage');
  if(st){var p2=st.closest('[data-elz-pdp]');show(p2,cur(p2)+d)}
});
var sx=null,sy=null;
document.addEventListener('touchstart',function(e){var st=e.target.closest&&e.target.closest('.elz-gal__stage');if(!st){sx=null;return}sx=e.touches[0].clientX;sy=e.touches[0].clientY},{passive:true});
document.addEventListener('touchend',function(e){
  if(sx===null)return;
  var st=e.target.closest&&e.target.closest('.elz-gal__stage');if(!st){sx=null;return}
  var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;sx=null;
  if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){var p=st.closest('[data-elz-pdp]');show(p,cur(p)+(dx<0?1:-1))}
},{passive:true});
function init(){
  $$('[data-elz-pdp]').forEach(function(p){
    if(p.__gal)return;p.__gal=1;sync(p);
    var stage=$('.elz-gal__stage',p);
    if(stage&&window.MutationObserver)new MutationObserver(function(){sync(p)}).observe(stage,{attributes:true,attributeFilter:['class'],subtree:true});
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();
